import { useRef, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.scss";
import { LiveAPIProvider } from "./contexts/LiveAPIContext";
import SidePanel from "./components/side-panel/SidePanel";
import { InterviewAssistant } from "./components/interview/Interview";
import ResumeUpload from "./components/resume-upload/ResumeUpload";
import { DSAPracticeCompanion } from "./components/dsacompanion/dsacompanion";
import { StudyCompanion } from "./components/study-companion/StudyCompanion";
import ControlTray from "./components/control-tray/ControlTray";
import cn from "classnames";
import CoursePage from "./components/course/CoursePage";
import { useAuth, RedirectToSignIn } from "@clerk/react";
import Dashboard from "./components/dashboard/Dashboard";
import ConsoleHeader from "./components/ConsoleHeader"; // New Global Header

const API_KEY = process.env.REACT_APP_GEMINI_API_KEY as string;
if (typeof API_KEY !== "string") {
  throw new Error("set REACT_APP_GEMINI_API_KEY in .env");
}

const host = "generativelanguage.googleapis.com";
const uri = `wss://${host}/ws/google.ai.generativelanguage.v1alpha.GenerativeService.BidiGenerateContent`;

function App() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [videoStream, setVideoStream] = useState<MediaStream | null>(null);
  const { isSignedIn, isLoaded } = useAuth();

  if (!isLoaded) return null;
  if (!isSignedIn) return <RedirectToSignIn />;

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          
          {/* Static Route without LiveAPI wrappers (No console, no tablet) */}
          <Route path="/course" element={
            <div className="streaming-console">
              <ConsoleHeader />
              <div className="console-body">
                <main style={{ overflow: "hidden", height: "100%" }}>
                  <div className="main-app-area" style={{ height: "100%", padding: 0 }}>
                    <CoursePage />
                  </div>
                </main>
              </div>
            </div>
          } />

          {/* Codevid - embedded as iframe, no LiveAPI needed */}
          <Route path="/codevid" element={
            <div className="streaming-console">
              <ConsoleHeader />
              <div className="console-body">
                <main style={{ overflow: "hidden", height: "100%" }}>
                  <div className="main-app-area" style={{ height: "100%", padding: 0 }}>
                    <iframe
                      src="/codevid/index.html"
                      style={{ width: "100%", height: "100%", border: "none" }}
                      title="Codevid"
                    />
                  </div>
                </main>
              </div>
            </div>
          } />

          {/* All other routes use the main layout with streaming-console & Live API components */}
        <Route
          path="*"
          element={
            <LiveAPIProvider url={uri} apiKey={API_KEY}>
              <div className="streaming-console">
                <ConsoleHeader />
                <div className="console-body">
                  <SidePanel />
                  <main>
                  <div className="main-app-area">
                    <Routes>
                      <Route path="/resupload" element={<ResumeUpload />} />
                       {/* Notice: /interview logic is retained for access post-resume */}
                      <Route path="/interview" element={<InterviewAssistant />} />
                      <Route path="/dsa" element={<DSAPracticeCompanion />} />
                      <Route path="/study" element={<StudyCompanion />} />
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                      <video
                        className={cn("stream", {
                          hidden: !videoRef.current || !videoStream,
                        })}
                        ref={videoRef}
                        autoPlay
                        playsInline
                      />
                    </div>

                    <ControlTray
                      videoRef={videoRef}
                      supportsVideo={true}
                      onVideoStreamChange={setVideoStream}
                    >
                      {/* put your own buttons here */}
                    </ControlTray>
                  </main>
                </div>
              </div>
            </LiveAPIProvider>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
